import React from 'react';
import PropTypes from 'prop-types';
import { Container, Label } from './css';

const SecondaryButton = ({
  label, size = 'default', iconSrc, showArrow = true, isIconLeftPosition, children, ...rest
}) => (
  <Container size={size} onMouseUp={(e) => e.target.blur()} showarrow={showArrow.toString()} {...rest}>
    <Label size={size} iconSrc={iconSrc} showarrow={showArrow.toString()} isIconLeftPosition={isIconLeftPosition}>{label || children}</Label>
  </Container>
);

SecondaryButton.propTypes = {
  label: PropTypes.string,
  size: PropTypes.string,
  iconSrc: PropTypes.string,
  showArrow: PropTypes.bool,
  isIconLeftPosition: PropTypes.bool,
  children: PropTypes.node,
};

export default SecondaryButton;
